import { Component } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component({
    template: `<button v-scroll="handleScroll" class="c-button-scroll-top" :class="{'is-visible': isVisible}" @click="scrollTop"></button>`,
})
export default class ScrollTop extends BaseComponent {
    protected isVisible: boolean = false;

    public scrollTop(): void {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    protected handleScroll() {
        const visible = window.scrollY > 800;
        if (visible !== this.isVisible) {
            this.isVisible = visible;
        }
    }

    protected mounted(): void {
        this.handleScroll();
    }
}
